(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["password__main"]) return;
  try {
    

$(document).ready(function () {
            $(".lunching-date p").on('click', function () {
                $(".password-page .overlay-data").css({
                  "opacity": 1,
                  "visibility": "visible",
                 });

          });

         $("#close-me").on('click', function () {
                 $(".password-page .overlay-data").css({
                   "opacity": 0,
                   "visibility": "hidden",
                  });

          });
       
        });

$(window).on('load', function(){
   $(".plyr__poster").trigger("click");
          $(".plyr__control").addClass("click");

  
});
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product__main"]) return;
  try {
    
   $(document).ready(function(){
       $('.toggle').click(function(e) {
  	e.preventDefault();

    let $this = $(this);
  
    if ($this.next().hasClass('shows')) {
        $this.next().removeClass('shows');
        $this.next().slideUp(350);
         $this.removeClass('active');
    } else {
        $this.parent().parent().find('li .inner').removeClass('shows');
        $this.parent().parent().find('li .inner').slideUp(350);
         $this.parent().parent().find('li .toggle').removeClass('active'); // Remove active class from all toggles
        $this.next().toggleClass('shows');
        $this.next().slideToggle(350);
        $this.addClass('active');
    }
});
});
  
  } catch(e) { console.error(e); }
})();
})();
